import { MarppleShopLoadingView } from '../../renderApp/components/atoms/Loading/MarppleShopLoadingView';

type LoaderOptions = {
  parent?: HTMLElement | string;
  styles?: Partial<CSSStyleDeclaration>;
};

/**
 * @example
 * ```ts
 * // start
 * await MarppleShopLoader.start();
 * await MarppleShopLoader.start(2000);
 * ```
 *
 * ```ts
 * // end
 * MarppleShopLoader.end();
 * ```
 */
export class MarppleShopLoader {
  // use client
  public static async start(timeout_ms?: number, options?: Readonly<LoaderOptions>): Promise<void> {
    return new Promise((resolve) => {
      const parent = this.resolveParent(options?.parent);
      this.removeExisting(parent);

      const loaderEl = new MarppleShopLoadingView(true).render();

      if (options?.styles) {
        Object.assign(loaderEl.style, options.styles);
      }

      parent.appendChild(loaderEl);

      if (timeout_ms && timeout_ms > 0) {
        setTimeout(() => {
          this.end(parent);
          resolve();
        }, timeout_ms);
      } else {
        resolve();
      }
    });
  }

  // use client
  public static end(parentEl?: HTMLElement | string): void {
    const parent = this.resolveParent(parentEl);
    this.removeExisting(parent);
  }

  // use client
  private static resolveParent(el?: HTMLElement | string): HTMLElement {
    if (typeof el === 'string') {
      return document.querySelector(el) ?? document.body;
    }
    return el ?? document.body;
  }

  // use client
  private static removeExisting(parent: HTMLElement): void {
    const existing = parent.querySelector(`.${MarppleShopLoadingView}`);
    if (existing?.parentNode) {
      existing.parentNode.removeChild(existing);
    }
  }
}
